import React from "react";
import { Dispatcher } from "../../../../flux";
import Presentation from "./presentation";
import OverleafStore from "../../../../../../stores/overleaf-store";

export default class Preview extends React.Component {
  constructor() {
    super();
    this.state = {
      testDup: false,
      disabled: false
    };
    this.delete = this.delete.bind(this);
    this.duplicate = this.duplicate.bind(this);
    this.edit = this.edit.bind(this);
    this.stopEdit = this.stopEdit.bind(this);
    this.study = this.study.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.deck.uuid === nextProps.addCardsFocus) {
      document.getElementById(`add-cards-${nextProps.deck.uuid}`).focus();
    }
  }

  delete() {
    const uuid = this.props.deck.uuid;
    this.setState({ disabled: true }, () => {
      OverleafStore.deleteDeck(uuid)
        .then(Fraction.Helpers.removeVSTModal)
        .then(() => this.setState({ disabled: false }));
    });
    Fraction.Reporter.gaEvent("V3/flashcards/panel", uuid, "delete deck");
  }

  duplicate() {
    this.setState({ testDup: true });
    const { title, uuid } = this.props.deck;
    this.setState({ disabled: true }, () => {
      OverleafStore.duplicateDeck(uuid, {
        title: i18n.t("reader.flashcards.title-copy", { title: title })
      }).then(() => {
        this.setState({ disabled: false });
      });
    });
    Fraction.Reporter.gaEvent("V3/flashcards/panel", uuid, "duplicate deck");
  }

  edit() {
    this.setState({ editing: true });
  }

  stopEdit(deck) {
    this.setState({ editing: false }, () => {
      const el = document.getElementById(`edit-${deck.uuid}`);
      el && el.focus();
    });
  }

  study() {
    Fraction.Router.setRoute("/flashcards/deck/" + this.props.deck.uuid);
  }

  render() {
    const { disabled, editing } = this.state;
    const { deck, onClick, isbn } = this.props;
    return (
      <Presentation
        cancel={this.stopEdit}
        deck={deck}
        destroy={this.delete}
        disabled={disabled}
        duplicate={this.duplicate}
        edit={this.edit}
        editing={editing}
        isbn={isbn}
        onClick={onClick}
        study={this.study}
        testDup={this.state.testDup}
      />
    );
  }
}
